import * as Sentry from '@sentry/react'
import { BrowserTracing } from '@sentry/tracing'
import 'animate.css'
import { Toast } from 'components/toast'
import { CaixaRoleProvider } from 'contexts/CaixaRoleContext'
import React from 'react'
import 'react-bootstrap-typeahead/css/Typeahead.css'
import 'react-datepicker/dist/react-datepicker.css'
import ReactDOM from 'react-dom'
import { resolveLegacyBoot } from 'components/SmartLink'
import { APP_ENVIRONMENT } from 'sharedKernel/constants'
import { DarkThemeProvider } from 'sharedKernel/theme'
import './assets/scss/index.scss'
import './assets/style/form.css'
import './assets/style/globals.css'
import './assets/style/steps.css'
import { CreateRoutes } from './routes/routes'
import { QueryClientWrapper } from './sharedKernel/api'
import './sharedKernel/i18n/translate/config'
import { Provider, store } from './store'
import 'animate.css'

Sentry.init({
  dsn: 'https://1eb42cdef3724d5f8e5b2c4e9e0fffc3@o446935.ingest.sentry.io/6564991',
  integrations: [new BrowserTracing()],
  tracesSampleRate: 1.0,
  environment: APP_ENVIRONMENT
})

const renderApp = (): void => {
  ReactDOM.render(
    <Provider store={store}>
      <QueryClientWrapper>
        <DarkThemeProvider>
          <CaixaRoleProvider>
            <Toast />
            <CreateRoutes />
          </CaixaRoleProvider>
        </DarkThemeProvider>
      </QueryClientWrapper>
    </Provider>,
    document.getElementById('app-root')
  )
}

// smart-nav boot gate: decide shell-vs-legacy para a URL atual *antes* de montar, para que uma
// URL do shell redirecione direto em vez de pintar a página legacy primeiro e só depois dar o
// bounce ("double jump"). O #preloader cobre a espera (limitada); quando o veredito é 'shell'
// nunca chegamos a montar. Modo flag-aware desligado => resolve na hora e renderiza.
void resolveLegacyBoot().then((shouldRender) => {
  if (shouldRender) renderApp()
})
